import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { isNgTemplate } from '@angular/compiler';
import { Perfil } from '../model/perfil';

@Injectable({
  providedIn: 'root'
})
export class PerfilService {

  apiURL: string = environment.apiBaseUrl + 'perfil';

  constructor(private http: HttpClient) { }

  buscar(page: number, parametroConsulta: string, qtdItemPagina: number, filtro: any): Observable<any> {
    const params = new HttpParams()
    .set('page', page)
    .set('descricao', parametroConsulta)
    .set('qtdItemPagina', qtdItemPagina)
    .set('filtro', filtro);
    return this.http.get<any>(`${this.apiURL}/consulta`, {params});
  }

  salvar(perfil: Perfil): Observable<Perfil> {
    return this.http.post<Perfil>(this.apiURL, perfil);
  }

  alterar(perfil: Perfil): Observable<any> {
    return this.http.put<Perfil>(`${this.apiURL}`, perfil);
  }

  deletar(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiURL}/${id}`);
  }

  consultarPorId(id: number): Observable<Perfil> {
    return this.http.get<any>(`${this.apiURL}/${id}`);
  }

  buscarPerfisAtivo(): Observable<Perfil[]> {
    return this.http.get<Perfil[]>(`${this.apiURL}/listar`);
  }

}
